//Hooks - Funciones
import React, { useCallback, useState, useEffect } from "react";
import moment from "moment";
import {
  formatRut,
  getPublicKey,
  toBase64,
} from "../../helpers/autoAtencionHelpers";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { api } from "../../helpers/api";
import { AUTOATENCIONAPI } from "../../helpers/url";
import { SwalListStyle } from "./Styles";

//Assets
import {
  AiFillFileAdd,
  AiFillEye,
  AiFillEdit,
  AiFillFile,
  AiFillFileExclamation,
  AiOutlineEye,
  AiOutlineEyeInvisible,
} from "react-icons/ai";

//Componentes
import Tabla from "../tabla/Tabla";
import NumberFormat from "react-number-format";
import {
  ButtonGroup,
  Collapse,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { TextColored } from "../typography";
import IconButton from "../buttons/IconButton";
import useStorage from "../../helpers/useStorage";
import { verificarCedibilidad } from "../../helpers/validatecedibilidad";
import { CiCircleCheck } from "react-icons/ci";
import { CiCircleRemove } from "react-icons/ci";
import { esDocumentoCedible } from "../../helpers/pdfReader";
import { DecryptData } from "../../helpers/encrypt";
import Swal from "sweetalert2";
import { error } from "jquery";

const IconsCedivilidad = {
  error: <CiCircleRemove size={25} color={"red"} />,
  success: <CiCircleCheck size={25} color={"green"} />,
};

const Popovermessage = (message) => (
  <Popover id="popover-basic">
    <Popover.Title as="h3">Error</Popover.Title>
    <Popover.Content>{message}</Popover.Content>
  </Popover>
);

const TablaFacturas = ({
  type = "select",
  rows,
  setRows,
  files,
  setFiles,
  loading = false,
  setLoading,
  selectedRows,
  setSelectedRows,
  options = <></>,
  toggledClearRows = false,
}) => {
  const { height } = useWindowDimensions();
  const [expandedRow, setCurrentExpandedRow] = useState(null);
  const [{ rut, idcontacto, idcliente }] = useStorage("user", {}, "local");
  const [validateDocument, setValidateDocument] = useState({
    folio: [],
    status: "success",
    message: [],
    color: "black",
  });
  const [parametros] = useStorage("parametros_comerciales", {}, "session");

  const ordenarPorMonto = (a, b) => {
    if (a.mntTotal > b.mntTotal) {
      return 1;
    }
    if (b.mntTotal > a.mntTotal) {
      return -1;
    }
    return 0;
  };

  const CellHeader = ({ name }) => {
    return <span style={{ whiteSpace: "normal" }}>{name}</span>;
  };

  const ordenarPorEmision = (a, b) => {
    return new Date(b.fchEmis) - new Date(a.fchEmis);
  };

  const columns = [
    {
      name: <CellHeader name="Folio" />,
      selector: (row) => row.folio,
      width: "100px",
      center: true,
      sortable: true,
    },
    {
      name: <CellHeader name="Deudor" />,
      selector: (row) => row.rznSocRecep,
      width: "425px",
      center: true,
      sortable: true,
    },
    {
      name: <CellHeader name="RUT Deudor" />,
      selector: (row) => formatRut(row.rutRecep),
      width: "160px",
      center: true,
      sortable: true,
    },
    {
      name: <CellHeader name="Monto" />,
      width: "140px",
      selector: (row) => {
        return (
          <NumberFormat
            value={row.mntTotal}
            displayType={"text"}
            prefix={"$"}
            thousandSeparator={"."}
            decimalScale={0}
            decimalSeparator={","}
          />
        );
      },
      sortFunction: ordenarPorMonto,
      right: true,
      sortable: true,
    },
    {
      id: "emision",
      name: <CellHeader name="Fecha de Emisión" />,
      selector: (row) => moment(row.fchEmis).format("DD/MM/YYYY"),
      center: true,
      sortable: true,
      sortFunction: ordenarPorEmision,
    },
  ];

  const getBills = useCallback(async () => {
    try {
      const bills = JSON.parse(sessionStorage.getItem("bills"));
      const rejectedBills = JSON.parse(
        sessionStorage.getItem("facturasRechazadas")
      );

      if (type === "facturas-rechazadas") {
        // Utilizado en modal para cesion rechazada o con observaciones
        if (rejectedBills.length === 1) {
          setCurrentExpandedRow(rejectedBills[0].folio);
        }
        setRows(rejectedBills);
      } else {
        setRows(bills);
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }, [type, setRows, setLoading]);

  useEffect(() => {
    if (type !== "select" && rows.length === 0) {
      getBills();
    }
  }, [getBills, type, rows]);

  const handleChange = ({ selectedRows: selectedRow }) => {
    setSelectedRows(selectedRow);
  };

  /**
   * Valida un documento (PDF o XML) usando AWS Textract
   * @param {File} file - Archivo a validar
   * @param {string} fileType - Tipo de archivo ("pdf" o "xml")
   * @returns {Promise<{success: boolean, message: string}>}
   */
  const validateDocumentWithTextract = async (file, fileType, pass = false) => {
    try {
      // Mostrar loading
      setLoading(true);

      // Convertir archivo a base64
      const base64Documento = await toBase64(file);

      // Obtener y desencriptar RUT (mismo formato que endpoint ceder)
      const publicKey = await getPublicKey();
      const rutDesencriptado = DecryptData(rut, publicKey);

      // Construir URL del endpoint
      const url = AUTOATENCIONAPI.POST.VALIDAR_DOCUMENTO_TEXTRACT.replace(
        "{idcontacto}",
        idcontacto
      );

      let dbPassword;
      if (!pass) {
        const {
          data: {
            data: { siipassword },
          },
        } = await api.get(
          AUTOATENCIONAPI.GET.DATA_ENROLAMIENTO.replace("{iduser}", idcontacto)
        );
        dbPassword = DecryptData(siipassword, publicKey);
      }

      // Construir body del request
      const requestBody = {
        base64Documento,
        nombreArchivo: file.name,
        idPersona: idcliente,
        rut: rutDesencriptado,
        idUsuario: idcontacto,
        contraseniaSII: pass || dbPassword,
      };

      // Llamar al endpoint
      const response = await api.post(url, requestBody);

      // Extraer datos de la respuesta

      return {
        success: response.data?.exito === true,
        message: response.message || "Documento procesado",
      };
    } catch (error) {
      console.error("Error al validar documento con Textract:", error);

      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Ocurrió un error al validar el documento",
      };
    } finally {
      // Ocultar loading
      setLoading(false);
    }
  };

  const handleFile = async (file, rowId, fileType, tipoDTE) => {
    let message = [];
    let evaluacionCedibilidad = false;
    if (fileType === "pdf") {
      evaluacionCedibilidad = await esDocumentoCedible(file, Number(tipoDTE));
      const publicKey = await getPublicKey();
      const newRut = encodeURIComponent(DecryptData(rut, publicKey));
      message = verificarCedibilidad({
        evaluacionCedibilidad,
        clienteRut: rows.map((row) => row.rutRecep),
        nroDocumento: rowId,
      });

      const folios = validateDocument.folio.some((item) => item == rowId);
      const folio_array = validateDocument.folio;
      if (!folios) {
        folio_array.push(rowId);
      }

      // ============================================================
      // VALIDACIÓN CON TEXTRACT (para PDF y XML)
      // ============================================================

      const textractValidation = await validateDocumentWithTextract(
        file,
        fileType
      );

      let alertMessages = [];

      if (!textractValidation.success) {
        alertMessages.push(textractValidation.message);
        message.push(textractValidation.message);
      }

      setValidateDocument({
        folio: folio_array,
        status:
          !evaluacionCedibilidad || message.length > 0 ? "error" : "success",
        message: message,
        color: !evaluacionCedibilidad || message.length > 0 ? "red" : "green",
      });

      if (!evaluacionCedibilidad || message.length > 0) {
        alertMessages.push("El archivo no cumple con los requisitos");
      }

      if (alertMessages.length > 0) {
        let htmlContent =
          alertMessages.length == 1
            ? alertMessages[0]
            : `<ul style="${SwalListStyle}"><li>${alertMessages.join(
                "</li><li>"
              )}</li></ul>`;
        await Swal.fire({
          icon: "warning",
          title: "Advertencia",
          html: htmlContent,
          showConfirmButton: true,
        });
      }

      if (
        (message.length > 0 &&
          parametros["PAA: validacion PDF cedible"] == 1) ||
        (!evaluacionCedibilidad &&
          parametros["PAA: validacion PDF cedible"] == 1)
      ) {
        return;
      }
    }

    // Encargado de administrar la carga de archivos para cada folio
    let obj = {
      ...files,
    };

    let cedible = 0;
    if (message.length > 0) {
      if (
        parametros["PAA: validacion PDF cedible"] == 1 ||
        parametros["PAA: validacion PDF cedible"] == 2
      ) {
        cedible = 2;
      }
    }

    if (!evaluacionCedibilidad && message.length == 0) {
      if (
        parametros["PAA: validacion PDF cedible"] == 1 ||
        parametros["PAA: validacion PDF cedible"] == 2
      ) {
        cedible = 2;
      }
    }

    if (evaluacionCedibilidad && message.length == 0) {
      if (
        parametros["PAA: validacion PDF cedible"] == 1 ||
        parametros["PAA: validacion PDF cedible"] == 2
      ) {
        cedible = 1;
      }
    }

    if (fileType === "pdf") {
      obj[rowId] = {
        ...obj[rowId],
        [fileType]: { name: file.name, url: URL.createObjectURL(file) },
        cedible: cedible,
      };
    }
    // } else {
    //   obj[rowId] = {
    //     ...obj[rowId],
    //     [fileType]: { name: file.name, url: URL.createObjectURL(file) },
    //   };
    // }

    setFiles(obj);

    const newRows = [...rows];

    // if (fileType === "xml") {
    //   newRows.forEach((e) => {
    //     if (e.folio === rowId) e.enlaceXml = file;
    //   });
    // }
    if (fileType === "pdf") {
      newRows.forEach((e) => {
        if (e.folio === rowId) {
          e.PDF = file;
          e.nombre_pdf = file.name;
        }
      });
    }
    setRows([...newRows]);
  };

  const params =
    "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no";

  const FilesInput = ({ rowId, fileType, tipoDTE }) => {
    const mimeTypes = {
      // xml: "application/xml",
      pdf: "application/pdf",
    };

    const checkAvailableFile = () => {
      if (files[rowId]) {
        if (files[rowId][fileType]) return true;
      }
    };

    return (
      <div>
        {/* // validateDocument,  */}
        {fileType == "pdf" &&
          validateDocument.folio.includes(rowId) &&
          (parametros["PAA: validacion PDF cedible"] == 1 ||
            parametros["PAA: validacion PDF cedible"] == 2) && (
            <OverlayTrigger
              trigger="hover"
              placement="top"
              overlay={
                <Popover id="popover-basic">
                  <Popover.Title as="h3">Error</Popover.Title>
                  <Popover.Content>
                    {validateDocument.status == "error" ? (
                      <>
                        <p style={{ color: "red" }} className="p-0  m-0">
                          * El archivo no cumple con los requisitos de
                          Cedibilidad:{" "}
                        </p>
                        <ul>
                          {validateDocument.message.length > 0 ? (
                            validateDocument.message.map((x) => (
                              <li style={{ color: "red" }}>{x}</li>
                            ))
                          ) : (
                            <li style={{ color: "red" }}>
                              El archivo es demasiado grande no se puede leer
                            </li>
                          )}
                        </ul>
                      </>
                    ) : (
                      <>
                        <p className="p-0  m-0" style={{ color: "green" }}>
                          * El archivo cumple con los requisitos de Cedibilidad
                        </p>
                      </>
                    )}
                  </Popover.Content>
                </Popover>
              }
            >
              <span>{IconsCedivilidad[validateDocument.status]}</span>
            </OverlayTrigger>
          )}

        <ButtonGroup>
          <input
            type="file"
            id={`upload-${fileType}${rowId}`}
            className="file-input"
            onChange={(e) => {
              handleFile(e.target.files[0], rowId, fileType, tipoDTE);
            }}
            accept={mimeTypes[fileType]}
          />
          <label
            htmlFor={`upload-${fileType}${rowId}`}
            className="upload-xml label"
          >
            {checkAvailableFile() ? <AiFillEdit /> : <AiFillFileAdd />}
          </label>

          <button
            className="view-xml"
            disabled={checkAvailableFile() ? false : true}
            onClick={() =>
              window.open(
                files[rowId][fileType].url,
                files[rowId][fileType].name,
                params
              )
            }
          >
            <AiFillEye />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  const handleExpandRow = (id) => {
    // Busco el boton con el numero de folio
    const button = document.getElementById(`row-expander-${id}`);
    const rowToClick = button?.parentNode;
    if (rowToClick) {
      // Busco el div superior de este boton el cual tiene capacidad de despachar funciones de columna, en este caso el expandable y lo clickeo
      rowToClick?.click();
    }
  };

  const aditionalColumns = {
    verFactura: {
      name: <CellHeader name="Ver factura" />,
      selector: (row) => {
        if (row.enlaceXml) {
          return (
            <a href={row.enlaceXml}>
              <AiFillFile color="black" />
            </a>
          );
        } else {
          return (
            <span>
              <AiFillFileExclamation size="1.5rem" color="grey" />
            </span>
          );
        }
      },
      button: true,
    },
    // cargaXml: {
    //   name: <CellHeader name="XML" />,
    //   selector: ({ folio }, i) => {
    //     return <FilesInput rowId={folio} fileType="xml" key={`upXml-${i}`} />;
    //   },
    //   center: true,
    // },
    cargaPdf: {
      name: <CellHeader name="PDF" />,
      selector: (row, i) => {
        return (
          <FilesInput
            rowId={row.folio}
            fileType="pdf"
            key={`upPdf-${i}`}
            tipoDTE={row.tipoDTE}
          />
        );
      },
      center: true,
      width: "180px",
    },
    plazo: {
      name: <CellHeader name="Plazo de pago (días)" />,
      selector: ({ plazo }) => plazo,
      center: true,
      width: "180px",
      sortable: true,
    },
    motivo: {
      name: <CellHeader name="Motivo" />,
      selector: ({ folio }) => {
        return (
          <IconButton
            Icon={
              folio !== expandedRow ? (
                <AiOutlineEyeInvisible size={25} />
              ) : (
                <AiOutlineEye size={25} />
              )
            }
            id={`row-expander-${folio}`}
            onClick={() => handleExpandRow(folio)}
          />
        );
      },
      center: true,
      width: "80px",
    },
  };

  const conditionalStyles = [
    {
      when: (row) => !selectedRows.includes(row),
      classNames: ["notSelected"],
    },
  ];

  const typeObj = {
    select: {
      data: { rows, columns: [...columns] },
      rows: height < 768 ? 4 : 5,
      conditionals: conditionalStyles,
      selectable: true,
      onSelected: handleChange,
    },
    show: {
      data: {
        rows,
        columns: [aditionalColumns.plazo, ...columns],
      },
      rows: height < 768 ? 3 : 5,
    },
    archives: {
      data: {
        rows,
        columns: [
          ...columns,
          //aditionalColumns.cargaXml,
          aditionalColumns.cargaPdf,
        ],
      },
      rows: 5,
    },
    archives_myBiller: {
      data: {
        rows,
        columns: [...columns, aditionalColumns.cargaPdf],
      },
      rows: 5,
    },
    "facturas-rechazadas": {
      data: {
        rows,
        columns: [...columns, aditionalColumns.motivo],
      },
      rows: 6,
    },
    "facturas-aceptadas": {
      data: {
        rows,
        columns: [...columns],
      },
      rows: 5,
    },
  };

  // Expandable row props
  const ExpandableComponent = ({ data: { motivo } }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
      setShow(true);
    }, []);

    return (
      <div>
        <Collapse in={show === true}>
          <div
            className="d-flex"
            style={{
              background: "#f9f9f9",
              paddingInline: "1rem",
              paddingBlock: "10px",
              boxShadow: "rgb(0 0 0 / 14%) 0px 5px 5px 0px inset",
            }}
          >
            <TextColored size={0.9} weight={500} type="dark">
              {motivo}
            </TextColored>
          </div>
        </Collapse>
      </div>
    );
  };

  const handleExpandedRow = (e, { folio }) => {
    if (expandedRow === folio && !e) {
      setCurrentExpandedRow(null);
      return;
    }
    setCurrentExpandedRow(folio);
  };
  //

  // Este objeto se puede usar para mandar propiedades que no esten agregadas en el componente principal (Tabla) para no tener que modificarlo
  const additionalProps = {
    "facturas-rechazadas": {
      expandableRows: true,
      expandableRowsComponent: ExpandableComponent,
      expandOnRowClicked: true,
      expandableIcon: {
        collapsed: <AiOutlineEye size={25} />,
        expanded: <AiOutlineEyeInvisible size={25} />,
      },
      onRowExpandToggled: handleExpandedRow,
      expandableRowExpanded: ({ folio }) =>
        folio === expandedRow || rows?.length === 1,
      expandableRowsHideExpander: true,
    },
  };

  return (
    <div id="tabla-facturas">
      {options}
      <Tabla
        datos={typeObj[type].data}
        busqueda={false}
        paginacion={typeObj[type]?.data?.rows?.length > typeObj[type]?.rows}
        selectableRows={typeObj[type]?.selectable}
        onSelectedRowsChange={typeObj[type]?.onSelected || {}}
        numeroFilas={typeObj[type]?.rows || 0}
        conditionalRowStyles={typeObj[type]?.conditionals || {}}
        loading={loading}
        type="checkbox"
        toggledClearRows={toggledClearRows}
        defaultSortFieldId="emision"
        defaultSortAsc={true}
        otherProperties={additionalProps[type] || {}}
      />
    </div>
  );
};

export default TablaFacturas;
